import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Avatar,
  Button,
  Stack,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";
import { account, databases } from "../lib/appwrite";
import ShipmentForm from "../components/ShipmentForm";
import ShipmentsTable from "../components/ShipmentsTable";
import { useNavigate } from "react-router-dom";

const DB_ID = process.env.REACT_APP_APPWRITE_DB_ID;
const COLLECTION_ID = process.env.REACT_APP_APPWRITE_COLLECTION_ID;

export default function AdminTrackingPage() {
  const [shipments, setShipments] = useState([]);
  const [editing, setEditing] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    account
      .get()
      .then(setUser)
      .catch(() => {
        setUser(null);
        navigate("/tracking/admin-panel/auth");
      });
  }, [navigate]);

  async function fetchShipments() {
    setLoading(true);
    setError(null);
    try {
      const res = await databases.listDocuments(DB_ID, COLLECTION_ID);
      setShipments(res.documents);
    } catch (err) {
      console.error("Error fetching shipments:", err);
      setError("Failed to load shipments. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (user) fetchShipments();
  }, [user]);

  async function logout() {
    await account.deleteSession("current");
    setUser(null);
    navigate("/tracking/admin-panel/auth");
  }

  if (!user) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 3 }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar>{user.name?.[0] || user.email[0]}</Avatar>
          <Box>
            <Typography variant="subtitle1">
              {user.name || user.email}
            </Typography>
          </Box>
        </Stack>
        <Button variant="outlined" onClick={logout}>
          Logout
        </Button>
      </Stack>

      <Typography variant="h4" gutterBottom>
        Admin Panel - India Shipments Tracking
      </Typography>

      <ShipmentForm
        editing={editing}
        setEditing={setEditing}
        onSaved={fetchShipments}
      />

      <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
        Active Shipments
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      ) : (
        <ShipmentsTable
          shipments={shipments}
          setEditing={setEditing}
          onDeleted={fetchShipments}
        />
      )}
    </Container>
  );
}
